export default __webpack_public_path__ + "static/media/steak.c72a09a3.png";